import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { store } from "../../store/store";

const baseUrl = process.env.REACT_APP_base_URL;

const deleteRequirementBoardApi = createApi({
    reducerPath: 'deleteRequirementBoardApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            // const token = useSelector((state)=> state.user.token)
            const token = store.getState().user.token;
            if (token) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        deleteRequirementBoard: builder.mutation({
            query: ({ boardId }) => ({
                url: `/requirement_boards/${boardId}`,
                method: 'DELETE',
            }),
            transformResponse: (response)=>{
                return response;
            }
        }),
    }),
});

export const { useDeleteRequirementBoardMutation } = deleteRequirementBoardApi;
export default deleteRequirementBoardApi;

